import React, { Component } from 'react';
import { Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class WidthSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
            width: this.props.width,
        };
        this.sm = this.props.widths.findIndex(item => item === 4) > -1;
        this.md = this.props.widths.findIndex(item => item === 6) > -1;
        this.lg = this.props.widths.findIndex(item => item === 12) > -1;
    }

    onChange = (width) => {
        this.props.log('WidthSelector.js/onChange (width)',width);
        this.setState({
            width: width
        }, () => this.props.callback(width))
    }

    render() {
        this.props.info('WidthSelector.js/render');
        return (
            <>
                {this.sm ? <Button
                    className={"p-0 widthButton " + (this.sm ?
                        ("btn-outline-light") : "btn-outline-secondary btn-secondary")} color={this.state.width === 4 ? "primary" : "secondary"}
                    onClick={() => this.onChange(4)}
                >S</Button> : <></>}
                {this.md ? <Button className={"p-0 widthButton " + (this.md ?
                    ("btn-outline-light") : "btn-outline-secondary btn-secondary")} color={this.state.width === 6 ? "primary" : "secondary"}
                    onClick={() => this.onChange(6)}
                >M</Button> : <></>}
                {this.lg ? <Button className={"p-0 widthButton " + (this.lg ?
                    ("btn-outline-light") : "btn-outline-secondary btn-secondary")} color={this.state.width === 12 ? "primary" : "secondary"}
                    onClick={() => this.onChange(12)}
                >L</Button> : <></>}
            </>
        );
    }
}

export default WidthSelector;
